import axios from 'axios';
import { Pagination } from 'components/Pagination';
import { Animate, Grid, Table, ViewContext } from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles.module.scss';
import { getLatestSubmissionNumber } from 'helpers/submission';

export function PendingCancellationPolicies(props) {
  const { id: company_id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const context = useContext(ViewContext);

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get(`/api/company/${company_id}`)
      .then(async (res) => {
        await axios
          .get(
            `/api/quote/policies?page=${page}&&company_id=${company_id}&status=pending_cancellation`
          )
          .then((res) => {
            setLoading(false);
            setPayload(res.data.data);

            var tempData = [];

            const formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            });

            const helper = new DateUtils();

            res.data.data.data.map((value) => {
              tempData.push({
                id: value.id,
                submission_number: getLatestSubmissionNumber(value),
                'Effective Date': helper.formatIsoToCommomDate(
                  value.effective_date
                ),
                carrier: Array.isArray(value.carrier)
                  ? value.carrier.join(', ')
                  : (value.carrier || 'N/A'),
                premium: formatter.format(value.premium),
                status: value.status.replaceAll('_', ' '),
              });
            });

            setData(tempData);
          })
          .catch((err) => {
            setLoading(false);

            context.notification.show(
              'Failed to load table data',
              'error',
              true,
              'toast',
              'x-circle'
            );
          });
      })
      .catch((err) => {
        console.log(err);

        context.notification.show(
          'Something went wrong!',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, '');
  }, []);

  return (
    <Animate type="pop">
      <div
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            onClick={() => {
              window.location.href = `/app/company/${company_id}/policies`;
            }}
            style={{
              backgroundColor: '#EAEAEA',
              width: '180px',
              color: '#090E3480',
              height: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'pointer',
            }}
          >
            Active
          </div>
          <div
            onClick={() => {
              window.location.href = `/app/company/${company_id}/policies/pending_cancellation`;
            }}
            style={{
              backgroundColor: 'black',
              color: '#fff',
              width: '230px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'pointer',
            }}
          >
            Pending Cancellation
          </div>
          <div
            onClick={() => {
              window.location.href = `/app/company/${company_id}/policies/canceled`;
            }}
            style={{
              backgroundColor: '#EAEAEA',
              width: '180px',
              color: '#090E3480',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'pointer',
            }}
          >
            Canceled
          </div>
        </div>
      </div>
      <Grid cols="1">
        <div className={styles.wrapper}>
          <Table
            loading={loading}
            data={payload && payload.data ? data : null}
            badge={{
              col: 'status',
              color: 'grey',
              condition: [
                { value: 'bound', color: 'green' },
                { value: 'pending cancelation', color: 'yellow' },
              ],
            }}
            hide={['link', 'id']}
          />
          {payload && (
            <Pagination
              pagesCount={payload.pages_count}
              active={payload.page}
              onChange={async (newPage) => {
                setPage(newPage);
                runAPI(newPage, searchQueryString);
              }}
            />
          )}
        </div>
      </Grid>
    </Animate>
  );
}
